"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pretensionRequestList = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.pretensionRequestList = (0, graphql_tag_1.default)`
  query pretensions_requests(
    $pretensionId: Int!
    $filters: [FilterCoreInput]
    $search: String
    $sort: PretensionRequestSortInput
    $before: Int
    $after: Int
    $first: Int
    $last: Int
    $sortByCheckbox: CheckboxSortInput
  ) {
    pretensions {
      requests(
        pretensionId: $pretensionId
        filters: $filters
        search: $search
        sort: $sort
        before: $before
        after: $after
        first: $first
        last: $last
        sortByCheckbox: $sortByCheckbox
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
        ids
        edges {
          node {
            id
            date
            number
            comment
            owner {
              id
              firstName
              lastName
              juristicPersonLegalForm
              juristicPersonName
              personType
              accessLevel
              membership
              role
              showMyAvatar
              avatarColor
              avatarBorderColor
              avatarText
              avatarDisplayName
              avatarUrl
              hasPrivateProfile
              isRegistered
              ownershipAddress
            }
            attachments {
              id
              path
              name
            }
          }
        }
      }
    }
  }
`;